import React from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { Helptext } from 'components/UIComponents/Form';
import { useTranslation } from 'react-i18next';

export default ({ errors, name }) => {
  const { t } = useTranslation();

  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => <Helptext color="danger">{t(message)}</Helptext>}
    />
  );
};
